import React from "react";
import logo from "../assets/logo.png"; // Adjust the path to your logo file

const Header = () => {
  return (
    <header className="w-100 text-center py-3 d-flex align-items-center justify-content-center" style={{ backgroundColor: "#1c246b", color: "white" }}>
      <img 
        src={logo} 
        alt="Logo" 
        style={{ height: "60px", width: "60px", borderRadius: "50%", marginRight: "15px" }} 
      />
      <h3 className="fw-bold" style={{ fontSize: "2.2rem", margin: 0 }}>YPO Flight Carbon Calculator (Beta)</h3>
    </header>
  );
};

export default Header;